module.exports = __webpack_public_path__ + "img/workNewsCover4.3514527c.png";